import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { SiaSessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class SiaSubtitleService {
  private sessionService = inject(SiaSessionService);

  private _subtitleChange: Subject<string> = new Subject();
  private _subtitleInformationChange: Subject<string> = new Subject();

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  subtitleChanged$() {
    return this._subtitleChange.asObservable();
  }

  subtitleInformationChanged$() {
    return this._subtitleInformationChange.asObservable();
  }

  getTitleAdditionalInformation(guid: string) {
    return this.sessionService.getTitleAdditionalInformation(guid);
  }

  getSubtitle(guid: string) {
    return this.sessionService.getSubtitle(guid);
  }

  setTitleAdditionalInformation(guid: string, subtitleInformation: string) {
    this.sessionService.setTitleAdditionalInformation(
      guid,
      subtitleInformation,
    );
    this._subtitleInformationChange.next(guid);
  }
  setSubtitle(guid: string, subtitle: string) {
    this.sessionService.setSubtitle(guid, subtitle);
    this._subtitleChange.next(guid);
  }
}
